import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../../../core/services/auth.service';
import { GlobalName } from '../../../../../core/utils/global-name';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../layout/includes/header/header.component';

@Component({
    selector: 'app-account-activation',
    templateUrl: './account-activation.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent],
    styleUrls: ['./account-activation.component.css']
})
export class AccountActivationComponent implements OnInit {
  loading:any
  password=''
  confirmPassword=''
  showPassword=false
  
    constructor(
      
      private authService:AuthService,
      private router: Router,
      private route:ActivatedRoute,
      private toastr: ToastrService,
      private lsService:LocalStorageService

    ) { }
  
    ngOnInit(): void {
 
      
    }
  
  
    isLongEnough(){
      return this.password.length >= 8
    }

    passwordsMatch(){
      return this.password === this.confirmPassword
    }

    canSubmit(){
      return this.isLongEnough() && this.passwordsMatch() && !this.loading
    }

    changeFirstPassword(value:any){

      if (!this.isLongEnough()) {
        this.toastr.error('Le mot de passe doit comporter au moins 8 caractères', 'Première connexion');
        return ;
      }

      if (!this.passwordsMatch()) {
        this.toastr.error('Les deux mots de passe ne sont pas identiques', 'Première connexion');
        return ;
      }
      this.loading=true
      this.authService.changeFirstPassword(value).subscribe((res:any)=>{
        this.loading=false
        this.logout()
        this.toastr.success('Changement de mot passe réussi', 'Première connexion');

       
      },
      (err:any)=>{
        this.loading=false
        this.toastr.error('Changement de mot passe échoué', 'Première connexion');
  
      });
    }

   
    logout(){
      this.authService.logout().subscribe((res:any)=>{
        this.lsService.remove(GlobalName.tokenName)
        this.lsService.remove(GlobalName.refreshTokenName)
        this.lsService.remove(GlobalName.expireIn)
        this.router.navigate(['/login'])
        this.toastr.success('Déconnexion réussie', 'Première Connexion');
      }),
      ((err:any)=>{
        console.log(err)
        this.toastr.success('Déconnexion échouée', 'Première Connexion');
  
      });
    }
}


